import { Stack } from '../../../../design-system/stack/stack';

type BeneficiaryNotFoundCardProps = {
  searchTerm: string;
};

export const BeneficiaryNotFoundCard = ({ searchTerm }: BeneficiaryNotFoundCardProps) => {
  return (
    <Stack
      align="center"
      space={1}
      className="rounded-lg border border-seapoint-gray-border bg-seapoint-gray-background-modal px-5 py-4"
    >
      <h3 className="text-center text-sm font-medium text-seapoint-gray-text">
        No results for <span className="text-black">{`"${searchTerm}"`}</span> were found among your recipients
      </h3>

      <p className="text-sm font-medium text-seapoint-gray-text">You can create a new recipient</p>
    </Stack>
  );
};
